import { InjectionToken } from '@angular/core';

export interface NotificationService {
  success(message: string, title?: string): void;
  error(message: string, title?: string): void;
  warning(message: string, title?: string): void;
  info(message: string, title?: string): void;
}

export const NOTIFICATION_SERVICE = new InjectionToken<NotificationService>(
  'NOTIFICATION_SERVICE'
);
